import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconTransfer = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconTransfer.dimensions.width} ${IconTransfer.dimensions.height}`}
      {...otherProps}
    >
      <G>
        <Path
          fill={color || Color.premiumBlack}
          d="M1.667 8.726v-.094l.008-6.765c0-.182.006-.363.01-.544.002-.141.093-.279.215-.309.137-.033.268-.014.358.124.026.04.046.095.048.143.01.31.019.62.02.93l.02 6.404v.097l.053-.057L3.451 7.49c.105-.114.232-.14.354-.077.123.062.2.203.195.359a.314.314 0 0 1-.078.202c-.216.25-.429.505-.649.751C2.938 9.1 2.6 9.47 2.26 9.84a.901.901 0 0 1-.106.095c-.113.089-.221.09-.324-.012a11.895 11.895 0 0 1-.486-.51C.926 8.94.51 8.467.097 7.992a.364.364 0 0 1-.045-.435c.08-.146.236-.212.384-.16a.212.212 0 0 1 .076.058c.29.315.578.631.867.948.093.102.184.206.288.323Zm5.666-6.452v.094l-.008 6.765c0 .182-.006.363-.01.544-.002.141-.093.279-.215.309-.137.033-.268.014-.358-.124a.294.294 0 0 1-.048-.143c-.01-.31-.019-.62-.02-.93l-.02-6.404v-.097l-.053.057L5.549 3.51c-.105.114-.232.14-.354.077A.384.384 0 0 1 5 3.228a.314.314 0 0 1 .078-.202c.216-.25.429-.505.649-.751C6.062 1.9 6.4 1.53 6.74 1.16a.901.901 0 0 1 .106-.095c.113-.089.221-.09.324.012.166.165.33.334.486.51.418.471.834.945 1.247 1.42a.364.364 0 0 1 .045.435c-.08.146-.236.212-.384.16a.212.212 0 0 1-.076-.058c-.29-.315-.578-.631-.867-.948-.093-.102-.184-.206-.288-.323Z"
        />
      </G>
    </Svg>
  )
}

IconTransfer.dimensions = {
  width: 9,
  height: 11,
}

export default IconTransfer
